import React from 'react';

import MUICheckbox from '@material-ui/core/Checkbox';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((_theme, _common) => ({
  checkbox: {
    margin: -9,
  },
}));

type MUICheckboxProps = React.ComponentProps<typeof MUICheckbox>;

export interface CheckboxProps extends Omit<MUICheckboxProps, 'onChange'> {
  value: boolean;
  checkedIcon?: React.ReactNode;
  onChange?: (value: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { value, onChange, className, checkedIcon, ...rest } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <MUICheckbox
      checked={value}
      checkedIcon={checkedIcon}
      onChange={() => {
        onChange?.(!value);
      }}
      color="primary"
      classes={{ root: clsx(classes.checkbox, className) }}
      {...rest}
    />
  );
};
